module.exports = __webpack_public_path__ + "img/icon-radiator.cbe76729.svg";